import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { HorizontalSettings_T, Splitter, UnbalancedBox } from '../../state/network-parameters.model.generated';

@Component({
  selector: 'app-diagram-horizontal',
  templateUrl: './diagram-horizontal.component.html',
  styleUrls: ['./diagram-horizontal.component.scss']
})
export class DiagramHorizontalComponent implements OnInit, OnChanges {

  @Input()
  horizontalSettings: HorizontalSettings_T;

  allSplitters: Splitter[] = [];
  boxes: UnbalancedBox[] = [];

  constructor() { }

  ngOnInit(): void {

  }

  private addAttendanceSplitter() {
    this.allSplitters.push(this.horizontalSettings.attendance_splitter);
  }

  private addSplitters() {
    this.horizontalSettings.splitter_sections.forEach(section => this.allSplitters.push(section.splitter));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.horizontalSettings) {
      console.log('Topology changed.');
      console.log(changes.horizontalSettings.currentValue);
      this.resetTopology();
    }
  }

  private resetTopology() {
    this.allSplitters = [];
    if (this.horizontalSettings.network_type === 'balanced') {
      this.addSplitters();
      this.addAttendanceSplitter();
    } else {
      this.addSplitters();
    }
    this.boxes = this.horizontalSettings.bus_box_types;
  }
}
